import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import LayoutContainer from '../LayoutContainer/LayoutContainer';
import envConfigPropTypes from '../../../states/envConfig/propTypes';
import { TYPE_CHAPS } from '../../../config';
import { setPaymentType } from '../../../states/modes/actions';
import { initialiseBatch } from '../../../states/batch/actions';
import { toggleChapsEditing } from '../../../states/chaps/actions';
import chapsReviewContent from '../ChapsReviewPage/chapsReview.content';
import withContent from '../../../containers/withContent';

const mapDispatch = (dispatch) => ({
	setPaymentType: (paymentType) => dispatch(setPaymentType(paymentType)),
	initialiseBatch: (batchDetails) => dispatch(initialiseBatch(batchDetails)),
	toggleChapsEditing: () => dispatch(toggleChapsEditing()),
});

class App extends Component {
	constructor(props) {
		super(props);
		const { setPaymentType, paymentToEdit, toggleChapsEditing, paymentDetails = {} } = this.props;
		const { batchDetails } = paymentDetails;

		setPaymentType({ paymentType: TYPE_CHAPS });

		if (batchDetails) initialiseBatch(batchDetails);
		if (paymentToEdit || batchDetails) toggleChapsEditing();
	}

	render() {
		const {
			copCheckTriggered,
			handleRoute,
			envConfig,
			handleSelectPaymentType,
			isBootStrapInProgress,
			handlePaymentInReview,
			resetPaymentList,
			handleComplete,
			handleBack,
			handleDisplayFullwidth,
			content: { content },
			sessionCOPChecks,
		} = this.props;
		return (
			<WebUIThemeProvider brandID={envConfig.brandId}>
				<LayoutContainer
					copCheckTriggered={copCheckTriggered}
					handleRoute={handleRoute}
					handleSelectPaymentType={handleSelectPaymentType}
					isBootStrapInProgress={isBootStrapInProgress}
					handlePaymentInReview={handlePaymentInReview}
					resetPaymentList={resetPaymentList}
					handleComplete={handleComplete}
					handleDisplayFullwidth={handleDisplayFullwidth}
					handleBackParent={handleBack}
					content={content}
					sessionCOPChecks={sessionCOPChecks}
				/>
			</WebUIThemeProvider>
		);
	}
}

App.propTypes = {
	handleRoute: PropTypes.func.isRequired,
	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	setPaymentType: PropTypes.func.isRequired,
	handleSelectPaymentType: PropTypes.func.isRequired,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	handlePaymentInReview: PropTypes.func.isRequired,
	resetPaymentList: PropTypes.func,
	handleComplete: PropTypes.func,
	paymentToEdit: PropTypes.shape({ paymentId: PropTypes.string, account: PropTypes.string }),
	paymentDetails: PropTypes.shape({
		batchDetails: PropTypes.shape({
			id: PropTypes.string.isRequired,
			isBatch: PropTypes.bool.isRequired,
			name: PropTypes.string.isRequired,
		}),
	}),
	toggleChapsEditing: PropTypes.func,
	handleBack: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};
const contentWrapper = withContent({ content: chapsReviewContent });
export default compose(connect(null, mapDispatch), contentWrapper)(App);
